import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      gap: '50px',
      '@media (max-width: 768px)': {
        flexDirection: 'column'
      }
    },
    line1: {
      marginBottom: '20px'
    },
    panier: {
      marginBottom: '10px'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
